import { ConsentCategory, ConsentPlugin } from '../types';

// Used for tenants with a static cookie policy but no CMP.
// Analytics and logging are granted by policy; marketing requires explicit opt-in.
const GRANTED_CATEGORIES: ConsentCategory[] = [
  'essential',
  'analytics',
  'logging',
];

export function createCookiePolicyPlugin(): ConsentPlugin {
  return {
    init() {},
    hasConsent(category: ConsentCategory) {
      return GRANTED_CATEGORIES.includes(category);
    },
    setCookiesLanguage() {},
  };
}
